import { Component, ViewEncapsulation } from '@angular/core';

/**
 * @ngdoc component
 * @name ApExplanationComponent
 */
@Component({
    selector: 'ap-explanation',
    templateUrl: './explanation.component.html',
    styleUrls: ['./explanation.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class ApExplanationComponent {}
